jQuery(document).ready(function($) {
	
	var fontFamily = 'Lato';
	var selectedIndex = false;
	var defaultColors = [
		'#7ab8e5',
		'#2988ce',
		'#1e669b',
		'#144467',
		'#a7d0ee',
		'#7ab8e5',
		'#2988ce',
		'#1e669b',
		'#144467',
		'#a7d0ee',
		'#7ab8e5',
		'#2988ce',
		'#1e669b',
		'#144467',
		'#a7d0ee',
		'#7ab8e5',
		'#2988ce',
		'#1e669b',
		'#144467',
		'#a7d0ee'
	];
	var defaultBarColors = {
		blue: [
			'#2888ce',
			'#7ab8e5'
		]
	};

	$('.chart.bar').each(function() {

		var ctx = document.getElementById($(this).attr('id')).getContext("2d");

		var data = {
			labels: $.parseJSON($(this).attr('data-horizontal-axis-labels')),
			datasets: $.parseJSON($(this).attr('data-datasets'))
		};

		var options = {
			barValueSpacing: 40,
            responsive: false,
            width:$(this).width(),
            height:300,
			legend: {
				display: false
			},
			layout: {
				padding: {
					left: 50,
					right: 50,
					top: 45,
					bottom: 0
				}
			},
			scales: {
				xAxes: [{
					gridLines: {
	   					display: false
					},
					ticks: {
						autoSkip: false,
						fontColor: '#232323',
						fontFamily: fontFamily,
						fontSize: 12,
							display: true,
		                    maxRotation: 0,
		                    minRotation: 0,
		                    fontWeight: 300,
		                    callback: function(value, index, values) {
		                        return value.split(' ');
		                    }
					}
				}],
				yAxes: [{
					gridLines: {
						display:false,
	        			drawBorder: false
					},
					ticks: {
						display: true,
	                	beginAtZero: true,
						fontFamily: fontFamily,
	                	fontColor: '#232323'
					},
					scaleLabel: {
						display: true,
						labelString: $(this).attr('data-vertical-axis-label')
					}
				}]
			},
			/*
			showTooltips: false,
            centeredInllineValues : true,
            tooltipCaretSize : 0,
            */
			tooltips: {
                //mode: 'nearest',
                //intersect: false,
                /*
				filter: function (tooltipItem) {
					return false;
					return tooltipItem.datasetIndex === 0; // Show tooltip only for first dataset
				},
				*/

         		callbacks: {
					title: function(tooltipItem, data) {
						return data['datasets'][tooltipItem[0]['datasetIndex']]['label'];
					},
					label: function(tooltipItem, data) {
						return data['datasets'][tooltipItem['datasetIndex']]['data'][tooltipItem['index']].replace('.', ',');
					}
				},

				backgroundColor: 'rgba(0,0,0,0)',
				titleFontSize: 11,
				titleFontStyle: 'normal',
				titleFontFamily: fontFamily,
				titleFontColor: '#6e6e6e',
				bodyFontSize: 13,
				bodyFontStyle: 'normal',
				bodyFontFamily: fontFamily,
				bodyFontColor: '#232323',
				xPadding: 0,
				yPadding: 4,
				/*
				titleAlign: 'center',
				bodyAlign: 'center',
				*/
				xAlign: 'center',
				yAlign: 'bottom',
				displayColors: false
			}
		};

		var myBarChart = new Chart(ctx, {
			type: 'bar',
			data: data,
			options: options
		});

	});


	/* Based off of: http://jsfiddle.net/nkzyx50o/ */
	Chart.pluginService.register({
		beforeDraw: function (chart) {
			if (chart.config.options.elements.center) {

				//Get ctx from string
				var ctx = chart.chart.ctx;

				//Get options from the center object in options
				var centerConfig = chart.config.options.elements.center;
				var fontStyle = centerConfig.fontStyle || 'Arial';
				ctx.fontWeight = '300';

				//Set font settings to draw it correctly.
				ctx.textAlign = 'center';
				ctx.textBaseline = 'middle';
				var centerX = ((chart.chartArea.left + chart.chartArea.right) / 2);
				var centerY = ((chart.chartArea.top + chart.chartArea.bottom) / 2);

				var lastActive = chart.lastActive[0];
				if (typeof lastActive === 'undefined') {
					var color = '#6e6e6e';
					var labelFontSize = (ctx.canvas.dataset.donutLargeInactiveLabel==='true') ? '40px' : '12px';
					ctx.font = labelFontSize + " " + fontStyle;
					ctx.fillStyle = color;
					ctx.fillText(ctx.canvas.dataset.donutInactiveLabel, centerX, centerY);
					return;
				}

				var currDataset = chart.chart.getDatasetMeta(lastActive._datasetIndex);
				var currLabel = currDataset.data[lastActive._index]._model.label;
				var currValue = chart.chart.data.datasets[0].data[lastActive._index];
				if (ctx.usesPercentage==='true') {
					currValue += '%';
				}
				
				var color = '#6e6e6e';
				ctx.font = "12px " + fontStyle;
				ctx.fillStyle = color;
				ctx.fillText(currLabel.toUpperCase(), centerX, centerY - 20);
				
				var color = '#232323';
				ctx.font = "32px " + fontStyle;
				ctx.fillStyle = color;
				ctx.fillText(currValue, centerX, centerY + 20);
			}
		}
	});

	$('.chart.pie').each(function() {
		
		var ctx = document.getElementById($(this).attr('id')).getContext("2d");
		ctx.usesPercentage = $(this).attr('data-uses-percentage');

		var options = {
			responsive: false,
            width:300,
            height:300,
			'cutoutPercentage': 56,
			legend: {
				display: false
			},
			tooltips: {
		      display: false,
		      enabled: false
		    },
			elements: {
				center: {
					color: '#232323',
					fontStyle: 'Lato',
				}
			},
			onHover: function (evt, elements) {
				if (elements && elements.length) {
					var segment = elements[0];
					if (selectedIndex !== segment["_index"]) {
						this.chart.update();
						selectedIndex = segment["_index"];
						segment._model.outerRadius += 8;
					} else {
						selectedIndex = null;
					}
				} else {
					this.chart.update();
				}
			},
			layout: {
				padding: 30
			}
		};

		var data = {
			datasets: [{
				data: $.parseJSON($(this).attr('data-pie-values')),
				backgroundColor: defaultColors,
				hoverBorderColor: defaultColors,
				hoverBackgroundColor: defaultColors,
				borderWidth: 0,
				hoverBorderWidth: 0,
				radius: 0,
				pointHoverRadius: 0
			}],
			labels: $.parseJSON($(this).attr('data-pie-labels'))
		};

		var myDoughnutChart = new Chart(ctx, {
			type: 'doughnut',
			data: data,
			options: options
		});


	});

	var sliderResizeTimeout = false;
	var resizeGraphSlider = function(slider) {
		var slide = slider.find('.slick-active');
		slider.find('.slide').animate({'height': slide.find('.inner-wrapper').height() + 50}, 150);
	}

	$('.graphs-slider').each(function() { 
		var sliderElement = $(this);
		sliderElement.slick({
			dots: true,
			arrows: false,
			autoplay: false,
			adaptiveHeight: false,
			infinite: true,
			draggable: false,
			swipe: false,
			cssEase: 'linear'
		});
		sliderElement.on('afterChange', function(event, slick, currentSlide){
			clearTimeout(sliderResizeTimeout);
			sliderResizeTimeout = setTimeout(function(slider) {
				resizeGraphSlider(slider);
			}, 500, $(this));
		});
		resizeGraphSlider(sliderElement);
	});

	$(document)
	.on('click', '.advance-slick-slider', function(e) {
		e.preventDefault();
		var slider = $(this).closest('.flexible-content, .flexible-content-text-page').find('.graphs-slider');
		if ($(this).hasClass('next')) {
			slider.slick("slickNext");
		} else {
			slider.slick("slickPrev");
		}
	});

});